import { render, staticRenderFns } from "./seckillDetail.vue?vue&type=template&id=1c148a33&scoped=true"
import script from "./seckillDetail.vue?vue&type=script&lang=js"
export * from "./seckillDetail.vue?vue&type=script&lang=js"
import style0 from "./seckillDetail.vue?vue&type=style&index=0&id=1c148a33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c148a33",
  null
  
)

export default component.exports